import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (window.trustedTypes) {
  window.trustedTypes.createPolicy('angular', {
    createHTML: (input) => input,
    createScript: (input) => input,
    createScriptURL: (input) => input,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

const metaTag = document.createElement('meta');
metaTag.setAttribute('http-equiv', 'Content-Security-Policy');

metaTag.setAttribute(
  'content',
  `
    default-src 'self';
    script-src 'self' ${location.origin} https://www.google.com https://www.gstatic.com https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/;
    media-src 'self' *;
    frame-src 'self' https://www.google.com/recaptcha/ https://www.youtube.com https://www.youtube-nocookie.com *;
    base-uri 'self';
    style-src 'self' 'unsafe-inline' ${location.origin} https://fonts.googleapis.com;
    connect-src 'self' ${location.origin} https://*.sentry.onix.team https://sentry.onix.team https://ipapi.co/json https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/;
    img-src data: *;
    font-src 'self' data: https://fonts.gstatic.com;
  `,
);
document.head.appendChild(metaTag);
